module.exports = require('./helpers/bundle-url').getBundleURL('5D0wD') + "warning_alert.4eede6c8.svg";